import React, { useState, useEffect } from 'react';
import './Partners.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

function PartnersPage() {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPartners();
  }, []);

  const fetchPartners = async () => {
    try {
      const response = await fetch(`${API_URL}/api/partners`);
      const data = await response.json();
      setPartners(data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching partners:', error);
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="partners-page">
        <div className="container">
          <div className="loading">Loading partners...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="partners-page">
      <section className="partners-hero">
        <div className="container">
          <h1 className="page-title fade-in">Our Partners</h1>
          <p className="page-subtitle fade-in">
            Trusted communities and servers we work with
          </p>
        </div>
      </section>

      <section className="partners-content">
        <div className="container">
          {partners.length === 0 ? (
            <div className="no-partners">
              <p>No partners yet. Check back soon!</p>
            </div>
          ) : (
            <div className="partners-grid">
              {partners.map((partner) => (
                <div key={partner.id} className="partner-card glass">
                  <div className="partner-logo">
                    {partner.logo ? (
                      <img src={partner.logo} alt={partner.name} />
                    ) : (
                      <div className="partner-logo-placeholder">
                        {partner.name.charAt(0).toUpperCase()}
                      </div>
                    )}
                  </div>
                  <div className="partner-info">
                    <h3 className="partner-name">{partner.name}</h3>
                    {partner.description && (
                      <p className="partner-description">{partner.description}</p>
                    )}
                    {partner.discord_url && (
                      <a 
                        href={partner.discord_url} 
                        target="_blank" 
                        rel="noopener noreferrer"
                        className="partner-discord-link btn btn-discord"
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515a.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0a12.64 12.64 0 0 0-.617-1.25a.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057a19.9 19.9 0 0 0 5.993 3.03a.078.078 0 0 0 .084-.028a14.09 14.09 0 0 0 1.226-1.994a.076.076 0 0 0-.041-.106a13.107 13.107 0 0 1-1.872-.892a.077.077 0 0 1-.008-.128a10.2 10.2 0 0 0 .372-.292a.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127a12.299 12.299 0 0 1-1.873.892a.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028a19.839 19.839 0 0 0 6.002-3.03a.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03zM8.02 15.33c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.956-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.956 2.418-2.157 2.418zm7.975 0c-1.183 0-2.157-1.085-2.157-2.419c0-1.333.955-2.419 2.157-2.419c1.21 0 2.176 1.096 2.157 2.42c0 1.333-.946 2.418-2.157 2.418z"/>
                        </svg>
                        Join Discord
                      </a>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}

export default PartnersPage;
